import { Validator } from '@vista-digital/validator';
import { ButtonColor } from '../../../../subcomponents/button/types/color';
import { defaultFormConfig, formConfigValidatorSchema } from '../../../../subcomponents/form/form/types/config';
import { defaultTicketRedemptionCodeFormValidationConfig, ticketRedemptionCodeFormValidationConfigValidator } from './validation-config';
export const defaultTicketRedemptionCodeFormConfig = {
    submitButton: Object.assign(Object.assign({}, defaultFormConfig.submitButton), { color: ButtonColor.Secondary }),
    cancelButton: Object.assign(Object.assign({}, defaultFormConfig.cancelButton), { show: false }),
    validation: defaultTicketRedemptionCodeFormValidationConfig,
    attemptToAutomaticallyAddTickets: true,
    showFieldLabels: false,
    enableSearch: true
};
export const ticketRedemptionCodeFormConfigValidator = Validator.object(Object.assign(Object.assign({}, formConfigValidatorSchema), { validation: ticketRedemptionCodeFormValidationConfigValidator, attemptToAutomaticallyAddTickets: Validator.boolean(), showFieldLabels: Validator.boolean(), enableSearch: Validator.boolean() }));
